export default __webpack_public_path__ + "static/dm-d682ae4c7e04ebee1fdf01f478dfaa16.svg";